"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.embadableURL = void 0;
var filters_1 = require("./filters");
var injectHttps_1 = require("../../../utils/injectHttps");
var embadableURL = function (value, isValidURL) {
    switch (true) {
        case value === null || value === void 0 ? void 0 : value.includes('docs.google.com'):
            return (0, filters_1.filterPPTURL)(value);
        case value === null || value === void 0 ? void 0 : value.includes('<iframe'):
            return (0, filters_1.filterIFrameURL)(value);
        default:
            return isValidURL && (0, injectHttps_1.injectHttps)(value);
    }
};
exports.embadableURL = embadableURL;
